import React from 'react';
import styles from './SummaryWrapper.module.scss';
import clsx from 'clsx';

export default function SummaryWrapper({ className, children }) {
  return <div className={clsx(className && className, styles.wrapper)}>{children}</div>;
}
